import { FormBaseTableComponent } from '../form-base-table/form-base-table.component';
import { Component } from '@angular/core';
import { deknKeys } from '@libs/shared/form-helpers/forms/forms-json-keys';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { ButtonComponent } from '../../../../../../components/kit/button/button.component';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-form-dekn-table',
    templateUrl: './form-dekn-table.component.html',
    styleUrls: ['../form-base-table/form-base-table.scss'],
    imports: [
        TableComponent,
        PrimeTemplate,
        ButtonComponent,
        Tooltip,
        TranslatePipe,
    ],
})
export class FormDeknTableComponent extends FormBaseTableComponent {

    evaluationNames = ['veryBad', 'bad', 'deteriorated', 'good'];

    constructor() {
        super();
        this.generateColumns(deknKeys);
    }
}
